import { Order, OrderEvent } from 'types/api/order'
import { Product, ProductIds } from 'types/model/product'

export const findRefundedProduct = (productId: number, order: Order) => {
  return order.parts.length > 0
    ? (order.parts
        .map((part) => part.products)
        .flatMap((product) => product)
        .filter((product) => Number(product.id) === productId)[0] as Product)
    : null
}

export const getProductFilteringInfo = (events: OrderEvent[], order: Order) => {
  if (!events || events.length < 1) {
    return []
  }
  const productIds = [] as ProductIds[]
  events.forEach((event) => {
    if (event.data.ean && event.data.sku) {
      productIds.push({
        gtin: event.data.ean as number,
        sku: event.data.sku as string,
      })
    }
    if (event.data.productId) {
      const product = findRefundedProduct(event.data.productId, order)
      if (product)
        if (event.data.ean && event.data.sku) {
          productIds.push({
            gtin: event.data.ean as number,
            sku: event.data.sku as string,
          })
        }
    }
  })
  return productIds
}
